import type * as Router from "@kestrel/router";

/**
 *
 */
export const defineRoute = ((route: unknown) => {
  /*                                                            */
  return route as never;
}) satisfies typeof Router.defineRoute;
